import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import gsap from 'gsap';

/**
 * PageLoader Component
 *
 * Inline loading indicator for page transitions with GSAP bouncing dots.
 * Used as Suspense fallback for lazy-loaded routes.
 */
export function PageLoader() {
  const { t } = useTranslation('common');
  const containerRef = useRef<HTMLDivElement>(null);
  const dotsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (dotsRef.current) {
        const dots = dotsRef.current.children;
        gsap.to(dots, {
          y: -8,
          duration: 0.4,
          ease: 'power2.out',
          stagger: { each: 0.15, repeat: -1, yoyo: true },
        });
      }
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div
      ref={containerRef}
      className="flex flex-col items-center justify-center py-12 gap-3"
    >
      <div ref={dotsRef} className="flex gap-2">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="w-2 h-2 rounded-full"
            style={{ background: '#F4D35E' }}
          />
        ))}
      </div>
      <p className="text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>
        {t('loadingPage')}
      </p>
    </div>
  );
}

export default PageLoader;
